exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1e61dcf3] .el-card__body{height:100%}[data-v-1e61dcf3] .customebg-color-danger{background:#ff3a30!important}[data-v-1e61dcf3] .customebg-color-alarm{background:#ff9502!important}[data-v-1e61dcf3] .customebg-color-risk{background:#f8b200!important}[data-v-1e61dcf3] .customebg-color-primary{background:#0082f7!important}", ""]);

// exports
